module.exports = __webpack_public_path__ + "img/two2Green.fd8aea64.png";